var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pageWithHeader"},[_c(_setup.MainHeader),_vm._v(" "),_c('div',{staticClass:"helpPage"}),_vm._v(" "),_c(_setup.HelpForm),_vm._v(" "),_c(_setup.HelpResult),_vm._v(" "),_c(_setup.MainFooter)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }